module.exports = __webpack_public_path__ + "static/media/vapour-img7.74089a4e.png";